import { Component, OnInit } from '@angular/core';
import { TeamSlider, TestimonialSlider } from '../../shared/data/slider';
import { ActivatedRoute, Router, ParamMap } from '@angular/router';
import { CommonService } from './../../shared/services/common.service';
@Component({
  selector: 'app-page',
  templateUrl: './page.component.html',
  styleUrls: ['./page.component.scss']
})
export class PageComponent implements OnInit {
  pageDetails: any[] = [];
  urlimage = '';
  datadone: boolean = false;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private Commen: CommonService
  ) {
    this.urlimage = this.Commen._ImageUrl + 'pages/';
  }

  ngOnInit(): void {

    this.route.params.subscribe(
      (params: ParamMap) => {
        const page_id = params['id'];
        const page_name = params['name'];

        if (page_id != '' && page_id > 0) {
          this.Commen.getPageDetails(page_id).subscribe(products => {
            if (products.data) {
              this.pageDetails = products.data;
              //console.log"pageDetails",this.pageDetails);
              this.datadone = true

              // SET TITLE
              this.Commen.setTitle(this.pageDetails['title']);
            }
            else {
              this.datadone = false
              //console.log"no data in page details");
            }

          })
        }
      }
    );
  }

  public TeamSliderConfig: any = TeamSlider;
  public TestimonialSliderConfig: any = TestimonialSlider;

  // Testimonial Carousel
  public testimonial = [
    {
      image: 'assets/images/testimonial/1.jpg',
      name: 'Mark jkcno',
      designation: 'Designer',
      description: 'you how all this mistaken idea of denouncing pleasure and praising pain was born and I will give you a complete account of the system, and expound the actual teachings.',
    },
    {
      image: 'assets/images/testimonial/2.jpg',
      name: 'Adegoke Yusuff',
      designation: 'Content Writer',
      description: 'you how all this mistaken idea of denouncing pleasure and praising pain was born and I will give you a complete account of the system, and expound the actual teachings.',
    },
    {
      image: 'assets/images/testimonial/1.jpg',
      name: 'John Shipmen',
      designation: 'Lead Developer',
      description: 'you how all this mistaken idea of denouncing pleasure and praising pain was born and I will give you a complete account of the system, and expound the actual teachings.',
    }
  ]

  // Team 
  public team = [
    {
      image: 'assets/images/team/1.jpg',
      name: 'Mark jkcno',
      designation: 'Designer'
    },
    {
      image: 'assets/images/team/2.jpg',
      name: 'Adegoke Yusuff',
      designation: 'Content Writer'
    },
    {
      image: 'assets/images/team/3.jpg',
      name: 'John Shipmen',
      designation: 'Lead Developer'
    },
    {
      image: 'assets/images/team/4.jpg',
      name: 'Hileri Keol',
      designation: 'CEO & Founder at Company'
    },
    {
      image: 'assets/images/team/3.jpg',
      name: 'John Shipmen',
      designation: 'Lead Developer'
    }
  ]

}
